export const environment = {
    production: false,
    ApiAppUrl: 'https://idprpapidev.clavisco.com/',
    ApiUIUrl: 'https://idprpdev.clavisco.com/',
    env : 'Development',
    recatchaSiteKey: '6Lc9mfIqAAAAANTsS_Lt_5T7xejQahT6aYArGzp4'
  };